import React, { Component } from "react";
import OCPEntry from "./OCPEntry";

class OrderEntry extends Component {
  render() {
    return (
      <OCPEntry
        module="Order"
        Type="Order"
        No="Order"
        itemEntryPage="OrderItemEntry"
      />
    );
  }
}

export default OrderEntry;
